import { render } from "./registration.vue?vue&type=template&id=56a993bc"
import script from "./registration.js?vue&type=script&lang=js&external"
export * from "./registration.js?vue&type=script&lang=js&external"

import "./registration.vue?vue&type=style&index=0&id=56a993bc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__